import { Component, Input, OnInit } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { IWenji } from "libraries/interfaces/IWenji";
import * as moment from 'moment';
import { LabelService } from "libraries/service/label/label.service";
import { DateService } from "libraries/date/date.service";

declare const wenji: IWenji;

@Component({
    selector: 'travel-date',
    template: `
        <span *ngIf="dayText || date; else noDate"
              matTooltip="{{date ? (date | dateMoment: dateService.dateFormats.momentMedium):null}}"
              matTooltipClass="travel-date-tooltip"
              class="date-container">
            <span>{{dayText}}</span>
            <span class="shortcut-date" *ngIf="date">{{date | dateMoment:'D MMM'}}</span>
        </span>
        <ng-template #noDate>
            <span class="shortcut-date">{{noDateWording}}</span>
        </ng-template>
    `,
    styles: [`
        span.date-container {
            display: flex;
            flex-direction: column;
        }

        span.date-container span {
            white-space: nowrap;
        }

        ::ng-deep .travel-date-tooltip {
            position: relative;
            bottom: 40px;
            display: flex;
            flex-direction: column;
        }

        span.shortcut-date {
            font-size: .8em;
        }
    `],
})

export class TravelDateComponent implements OnInit {
    @Input()
    public beginDate: string;
    @Input()
    public quotationOffset: number;

    public dayText: string;
    public date: Date;

    public readonly noDateWording: string = Yii.t('wui-shared-js', 'Libre');

    constructor(private readonly labelService: LabelService,
                public readonly dateService: DateService,) {
    }

    public ngOnInit(): void {
        if (this.beginDate && this.quotationOffset) {
            this.date = moment(this.beginDate).add(this.quotationOffset-1, 'days').toDate();
            this.dayText = this.quotationOffset.toString();
        } else if (this.quotationOffset) {
            this.dayText = this.labelService.completeLabel(
                Yii.t('wui-shared-js', `Jour %placeholder%`),
                this.quotationOffset.toString());
        }
    }
}
